import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Login from './pages/Login';

import urls, { loginUrl } from './urls';

const LoginRoutes = () => {
  return (
    <Switch>
      <Route exact path={loginUrl()} component={Login} />
    </Switch>
  );
}

export const baseUrl = urls.base;

export default LoginRoutes;
